import { makeAutoObservable } from "mobx";

export enum Device {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
  LargeDesktop = "largeDesktop",
  WideDesktop = "wideDesktop",
}

export class BreakpointStore {
  private currentDevice: Device = Device.Desktop;

  private breakpoints: Record<Device, number> = {
    [Device.Mobile]: 480,
    [Device.Tablet]: 768,
    [Device.Desktop]: 1024,
    [Device.LargeDesktop]: 1200,
    [Device.WideDesktop]: 1440,
  };

  constructor() {
    makeAutoObservable(this);

    this.updateDeviceType();
    window.addEventListener("resize", this.updateDeviceType);

    setTimeout(() => {
      // Re-fetch breakpoints after styles have loaded
      this.breakpoints = this.getBreakpoints();
      this.updateDeviceType();
    }, 1000);
  }

  public updateDeviceType = () => {
    const width = window.innerWidth;
    if (width <= this.breakpoints.mobile) {
      this.currentDevice = Device.Mobile;
    } else if (width <= this.breakpoints.tablet) {
      this.currentDevice = Device.Tablet;
    } else if (width <= this.breakpoints.desktop) {
      this.currentDevice = Device.Desktop;
    } else if (width <= this.breakpoints.wideDesktop) {
      this.currentDevice = Device.WideDesktop;
    } else {
      this.currentDevice = Device.LargeDesktop;
    }
  };

  public get device() {
    return this.currentDevice;
  }

  public isSmallerThan(device: Device) {
    return window.innerWidth < this.breakpoints[device];
  }

  private getBreakpoints() {
    return {
      [Device.Mobile]: this.getBreakpointFromStyle("--breakpoint-mobile") ?? this.breakpoints.mobile,
      [Device.Tablet]: this.getBreakpointFromStyle("--breakpoint-tablet") ?? this.breakpoints.tablet,
      [Device.Desktop]: this.getBreakpointFromStyle("--breakpoint-desktop") ?? this.breakpoints.desktop,
      [Device.LargeDesktop]: this.getBreakpointFromStyle("--breakpoint-large-desktop") ?? this.breakpoints.largeDesktop,
      [Device.WideDesktop]: this.getBreakpointFromStyle("--breakpoint-wide-desktop") ?? this.breakpoints.wideDesktop,
    };
  }

  private getBreakpointFromStyle(style: string): number | undefined {
    const value = getComputedStyle(document.documentElement).getPropertyValue(style);
    const parsedValue = parseInt(value);
    return isNaN(parsedValue) ? undefined : parsedValue;
  }
}
